import React from 'react'
import Button from '@cloudscape-design/components/button'
import Alert from '@cloudscape-design/components/alert'
import SpaceBetween from '@cloudscape-design/components/space-between'

/**
 * ErrorMessage component
 * Displays user-friendly error messages with optional retry
 */
const ErrorMessage = ({ 
  message, 
  onRetry, 
  showRetry = true,
  type = 'error' // 'error', 'warning', 'info'
}) => {
  return (
    <Alert
      type={type}
      action={showRetry && onRetry && (
        <Button onClick={onRetry}>Retry</Button>
      )}
    >
      <SpaceBetween size="xs">
        {message}
      </SpaceBetween>
    </Alert>
  )
}

export default ErrorMessage
